/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPADDRESSTYPE } from './IAPADDRESSTYPE';
import {
    IAPADDRESSTYPEFromJSON,
    IAPADDRESSTYPEFromJSONTyped,
    IAPADDRESSTYPEToJSON,
} from './IAPADDRESSTYPE';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPPOSTALADDRESSTYPE } from './IAPPOSTALADDRESSTYPE';
import {
    IAPPOSTALADDRESSTYPEFromJSON,
    IAPPOSTALADDRESSTYPEFromJSONTyped,
    IAPPOSTALADDRESSTYPEToJSON,
} from './IAPPOSTALADDRESSTYPE';

/**
 * 
 * @export
 * @interface AddressViewModel
 */
export interface AddressViewModel {
    /**
     * 
     * @type {number}
     * @memberof AddressViewModel
     */
    id?: number;
    /**
     * 
     * @type {IAPADDRESSTYPE}
     * @memberof AddressViewModel
     */
    addressType?: IAPADDRESSTYPE;
    /**
     * 
     * @type {IAPPOSTALADDRESSTYPE}
     * @memberof AddressViewModel
     */
    postalAddressType?: IAPPOSTALADDRESSTYPE;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    complexOrEstateName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    unitNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    streetOrFarmOrPlotName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    suburbOrDistrict?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    cityOrTown?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof AddressViewModel
     */
    country?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    inCareOfNameAndSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    poBoxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    suite?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    privateBagNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressViewModel
     */
    sameAsPartyId?: number;
}

/**
 * Check if a given object implements the AddressViewModel interface.
 */
export function instanceOfAddressViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddressViewModelFromJSON(json: any): AddressViewModel {
    return AddressViewModelFromJSONTyped(json, false);
}

export function AddressViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'addressType': !exists(json, 'AddressType') ? undefined : IAPADDRESSTYPEFromJSON(json['AddressType']),
        'postalAddressType': !exists(json, 'PostalAddressType') ? undefined : IAPPOSTALADDRESSTYPEFromJSON(json['PostalAddressType']),
        'complexOrEstateName': !exists(json, 'ComplexOrEstateName') ? undefined : json['ComplexOrEstateName'],
        'unitNumber': !exists(json, 'UnitNumber') ? undefined : json['UnitNumber'],
        'streetOrFarmOrPlotName': !exists(json, 'StreetOrFarmOrPlotName') ? undefined : json['StreetOrFarmOrPlotName'],
        'streetNumber': !exists(json, 'StreetNumber') ? undefined : json['StreetNumber'],
        'suburbOrDistrict': !exists(json, 'SuburbOrDistrict') ? undefined : json['SuburbOrDistrict'],
        'cityOrTown': !exists(json, 'CityOrTown') ? undefined : json['CityOrTown'],
        'country': !exists(json, 'Country') ? undefined : IAPCOUNTRYFromJSON(json['Country']),
        'province': !exists(json, 'Province') ? undefined : json['Province'],
        'postalCode': !exists(json, 'PostalCode') ? undefined : json['PostalCode'],
        'inCareOfNameAndSurname': !exists(json, 'InCareOfNameAndSurname') ? undefined : json['InCareOfNameAndSurname'],
        'poBoxNumber': !exists(json, 'PoBoxNumber') ? undefined : json['PoBoxNumber'],
        'suite': !exists(json, 'Suite') ? undefined : json['Suite'],
        'privateBagNumber': !exists(json, 'PrivateBagNumber') ? undefined : json['PrivateBagNumber'],
        'sameAsPartyId': !exists(json, 'SameAsPartyId') ? undefined : json['SameAsPartyId'],
    };
}

export function AddressViewModelToJSON(value?: AddressViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'AddressType': IAPADDRESSTYPEToJSON(value.addressType),
        'PostalAddressType': IAPPOSTALADDRESSTYPEToJSON(value.postalAddressType),
        'ComplexOrEstateName': value.complexOrEstateName,
        'UnitNumber': value.unitNumber,
        'StreetOrFarmOrPlotName': value.streetOrFarmOrPlotName,
        'StreetNumber': value.streetNumber,
        'SuburbOrDistrict': value.suburbOrDistrict,
        'CityOrTown': value.cityOrTown,
        'Country': IAPCOUNTRYToJSON(value.country),
        'Province': value.province,
        'PostalCode': value.postalCode,
        'InCareOfNameAndSurname': value.inCareOfNameAndSurname,
        'PoBoxNumber': value.poBoxNumber,
        'Suite': value.suite,
        'PrivateBagNumber': value.privateBagNumber,
        'SameAsPartyId': value.sameAsPartyId,
    };
}

